<script>
import service from '@/request/base'
import moment from 'moment'

const notphoto = require('@/assets/record_no_image.png')
export default {
    name: 'RecordWindowCard',
    components: {},
    props: {
        data: {
            type: Object,
            default() {
                return {}
            }
        },
        diagnoseLevel: {
            type: Number,
            default() {
                return null
            }
        }
    },
    data() {
        return {
            icons: {
                shu: require('./icons/shu.png'),
                xin: require('./icons/xin.png'),
                zhuanru: require('./icons/zhuanru.png'),
                zhuanchu: require('./icons/zhuanchu.png')
            },
            bgc: [
                '#03d679',
                '#03b664',
                '#f5c700',
                '#fe9b00',
                '#e54400',
            ]
            // level: ['Ⅰ', 'Ⅱ', 'Ⅲ', 'Ⅳ', 'Ⅴ']
        }
    },
    computed: {},
    created () {
    },
    watch: {},
    methods: {
        handlerClickWindow() {
            this.$emit('click-window', this.data)
        },
        handleLeave() {
            this.$emit('click-leave', this.data)
        }
    },
    filters: {
        imageFilter(value) {
            if (!value) {
                return notphoto
            }
            return service.url(value)
        },
        dateFilter(time) {
            return moment(time).format('YYYY-MM-DD')
        }
    }
}
</script>

<template>
    <div class="record-window" @click="handlerClickWindow()">
        <div v-if="diagnoseLevel === 0 || diagnoseLevel"
             class="diagnoseLevel"
             :style="{backgroundColor: bgc[diagnoseLevel], fontSize: '2px'}">KL{{diagnoseLevel}}</div>
        <div class="followup-badge" v-if="data.hasFollowup"><i class="fas fa-comment-medical"></i></div>
        <div class="badge" :title="data.historySn"
             :style="{background: data.hospitalized === 0 ? '#8CC8FF' : (data.state === 7 ? '#E4E4E4' : '#87D068')}">
            <span class="outpatient" v-if="data.hospitalized === 0">{{ data.historySn }}</span>
            <span class="inhospital" v-if="data.hospitalized === 1 && !data.leaveTime">{{ data.bedid || '无'}}</span>
            <span class="leavehospital" v-if="data.hospitalized === 1 && data.state === 7">{{ data.bedid || '无'}}</span>
        </div>
        <div class="info-content">
            <div class="title clear">
                <div class="image clear">
                    <div class="image-wrap"><img :src="data.image | imageFilter"></div>
                </div>
                <div class="pat-info clear">
                    <h1 style="overflow: hidden; white-space: nowrap; text-overflow:ellipsis;">{{ data.patName }}</h1>
                    <span>{{ !!data.sex && data.sex % 2 === 0 ? '女' : '男' }}</span>
                    <span>{{ data.age }}岁</span>
                </div>
            </div>
            <div class="record-info">
                <!--        <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">-->
                <div class="record-item clear" v-if="data.diagnoseNames">
                    <span class="lable">诊断：</span>
                    <span class="text">{{data.diagnoseNames}}</span>
                </div>
                <div class="record-item clear" v-if="data.operatingNames">
                    <span class="lable">术式：</span>
                    <span class="text">{{data.operatingNames}}</span>
                </div>
                <!--<div class="record-item clear">
                  <span class="lable" v-if="data.hospitalized">手术状态</span>
                  <span class="lable" v-else>病情描述</span>
                  <span class="text" v-if="data.hospitalized">
                    <span v-if="data.state === 0 || data.state === 1 && data.end === 0">未申请</span>
                    <span v-else-if="data.state === 1 && data.end === 1" style="color: red;">(手术室退回:{{data.remark}})</span>
                    <span v-else-if="data.state === 1 && data.end === 2" style="color: red;">审批不通过</span>
                    <span v-else-if="data.state === 2">待审批</span>
                    <span v-else-if="data.state === 3">已审批</span>
                    <span v-else-if="data.state === 4">已排班</span>
                    <span v-else-if="data.state === 5">已完成</span>
                  </span>
                  <span class="text" v-else>{{data.stateOfAnIllness ? data.stateOfAnIllness : '无'}}</span>
                </div>
              </el-scrollbar>-->
            </div>
            <!--<div class="record-state-icons">
              <font v-if="data.state > 1 && data.state <= 5">
                <img :src="icons.shu"/>
              </font>
              <font v-if="(Date.parse(new Date()) - data.createTime) < 86400000">
                <img :src="icons.xin"/>
              </font>
              <font v-if="data.recommend === 2 || data.recommend === 5">
                <img :src="icons.zhuanru"/>
              </font>
              <font v-if="data.recommend === 1 || data.recommend === 3 || data.recommend === 4">
                <img :src="icons.zhuanchu"/>
              </font>
            </div>-->
        </div>
        <div class="window-footer clear">
            <time class="outpatient" v-if="data.hospitalized === 0">{{ data.admissionDate | dateFilter }}门诊</time>
            <time class="inhospital" v-if="data.hospitalized === 1 && !data.leaveTime">{{ data.admissionDate | dateFilter
                }}住院，未出院
            </time>
            <time class="leavehospital" v-if="data.hospitalized === 1 && data.state === 7">{{ data.admissionDate |
                dateFilter }}住院，{{data.leaveTime | dateFilter}}出院
            </time>
        </div>
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record-window {
    position: relative;
    height: 170px;
}
.diagnoseLevel {
    width: 22px;
    height: 22px;
    transform: scale(0.8);
    font-size: 12px;
    text-align: center;
    line-height: 22px;
    color: white;
    position: absolute;
    z-index: 999;
    margin-top: -6px;
    border-radius: 50%;
}
.image,
.info-content,
.pat-info,
.window-footer {
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
}

.image {
    width: 25%;
    height: auto;
    float: left;
}

.image-wrap {
    width: 100%;
    height: auto;
    padding-bottom: 100%;
    position: relative;
}

/*.image img {
  width:100%;
  height:100%;
  position:absolute;
  border-radius: 10px;
}*/
.image img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
    display: block;
    margin: auto;
    padding: auto;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
}

.info-content {
    width: 100%;
    padding: 0 10px;
}

.info-content .pat-info {
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    float: right;
    width: 75%;
    padding-left: 20px;
    padding-top: 5px;
}

.info-content .pat-info > span {
    margin-right: 10px;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    display: inline-block;
    height: 20px;
}

.info-content .pat-info > h1 {
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    height: 30px;
}

.record-info {
    overflow: hidden;
    padding-top: 20px;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
}

.record-info .record-item {
    width: 100%;
    margin-bottom: 5px;
    line-height: 22px;
}

.record-item .lable {
    text-align: left;
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.record-item .text {
    display: block;
}

.record-item span.text {
    word-break: break-all;
    text-overflow: ellipsis;
    /*display: -webkit-box; !** 对象作为伸缩盒子模型显示 **!
    -webkit-box-orient: vertical; !** 设置或检索伸缩盒对象的子元素的排列方式 **!
    -webkit-line-clamp: 1; !** 显示的行数 **!*/
    overflow: hidden; /** 隐藏超出的内容 **/
    white-space: nowrap;
}

.record-state-icons {
    margin: 8px 0;
    line-height: 24px;
    height: 24px;
    overflow: hidden;
}

.record-state-icons img {
    width: 21px;
    height: 21px;
}

.window-footer {
    line-height: 14px;
    font-size: 12px;
    padding: 10px;
    font-weight: 400;
    font-style: normal;
    color: #D7D7D7;
}

.badge {
    cursor: pointer;
    position: absolute;
    top: -20px;
    right: -20px;
    padding-top: 5px;
    color: #fff;
    z-index: 999;
    width: 80px;
    height: 30px;
    text-align: center;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
}

.followup-badge {
    position: absolute;
    top: -10px;
    left: -10px;
    color: #67C23A;
}

.badge > span {
    display: block;
    height: 25px;
    line-height: 30px;
    width: 70px;
    word-break: break-all;
    text-overflow: ellipsis;
    /*display: -webkit-box; !** 对象作为伸缩盒子模型显示 **!
    -webkit-box-orient: vertical; !** 设置或检索伸缩盒对象的子元素的排列方式 **!
    -webkit-line-clamp: 1; !** 显示的行数 **!*/
    overflow: hidden; /** 隐藏超出的内容 **/
    white-space: nowrap;
}
</style>
